import DisconnectedWalletContent from "./DisconnectedWalletContent";
import DisconnectedWalletTitle from "./DisconnectedWalletTitle";

export const DisconnectedWallet = {
  Content: DisconnectedWalletContent,
  Title: DisconnectedWalletTitle,
};
